import React from 'react';
import { renderCalendarPicker as RenderCalendarPicker } from 'components/form/datepicker/datetime-picker';

export default ({ label, input, meta, disabled, labelSize, qaId }) => (
  <RenderCalendarPicker
    label={label}
    input={input}
    meta={meta}
    disabled={disabled}
    labelSize={labelSize}
    qaId={qaId}
  />
);
